const isObject_ = require('lodash/isObject')
const has_ = require('lodash/has')

const isRecord = something => isObject_(something) && has_(something, '_id')

module.exports = isRecord



// WEBPACK FOOTER //
// ./helpers/isRecord.js